import { render, staticRenderFns } from "./RedimensionamentoHospitalarAgiFiltro.vue?vue&type=template&id=05b1b3ce"
import script from "./RedimensionamentoHospitalarAgiFiltro.vue?vue&type=script&lang=js"
export * from "./RedimensionamentoHospitalarAgiFiltro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports